import currency from "currency.js";

export const currencyFormatter = (value) =>
  currency(value, {
    symbol: "Rp ",
    separator: ".",
    decimal: ",",
    precision: 0,
  }).format();
